var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { CampaignService } from './campaign.service';
var CampaignMeasureComponent = /** @class */ (function (_super) {
    __extends(CampaignMeasureComponent, _super);
    function CampaignMeasureComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.defMode = '';
        _this.readonly = false;
        _this.campaignId = 0;
        _this.registryTypeId = 0;
        _this.segments = [];
        _this.registryTypeList = [];
        _this.registryList = {};
        _this.registryId = {};
        return _this;
    }
    CampaignMeasureComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    CampaignMeasureComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (this.component.params && this.component.params.mode) {
            this.defMode = this.component.params.mode;
        }
        if (this.component.params && this.component.params.readonly === true) {
            this.readonly = true;
        }
    };
    CampaignMeasureComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    CampaignMeasureComponent.prototype.onSubscribe = function (data) {
        this.campaignId = 0;
        if (data.campaign_id) {
            this.campaignId = data.campaign_id;
        }
        this.registryTypeId = 0;
        if (data.registry_type_id) {
            this.registryTypeId = data.registry_type_id;
        }
        else if (data.registryTypeM) {
            var registryTypeM = jsonpath.value(data, '$..registryTypeM');
            if (registryTypeM) {
                this.registryTypeId = registryTypeM.registry_type_id;
            }
        }
        this.segments = [];
        var segments = jsonpath.value(data, '$..segmentM');
        if (segments) {
            this.service.sortPriority(segments);
            for (var i = 0; i < segments.length; i++) {
                var rid = jsonpath.value(segments[i], '$.campaignMeasure.registry_id');
                this.segments.push(Object.assign(new Measure(), {
                    segment_id: segments[i].segment_id,
                    segment_title: segments[i].segment_title,
                    registry_id: rid
                }));
                this.registryId['registry_id-' + i] = rid;
            }
        }
        if (this.segments.length > 0) {
            this.getList();
            this.setCampaignMeasureData();
        }
    };
    CampaignMeasureComponent.prototype.onModeSubscribe = function (mode) {
        if (this.defMode !== mode) {
            this.action.deleteCompRec(this.componentName);
        }
    };
    CampaignMeasureComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    CampaignMeasureComponent.prototype.getList = function () {
        var _this = this;
        this.registryTypeList = [];
        this.registryList = {};
        this.service.getCampaignMeasureList(this.campaignId).subscribe(function (rec) {
            if (rec instanceof Array) {
                _this.registryTypeList.push({
                    code: 0,
                    display: _this.msgSnapshot['CampaignMeasureComponent.radio.unselected']
                });
                _this.registryList[0] = [];
                for (var _i = 0, rec_1 = rec; _i < rec_1.length; _i++) {
                    var r = rec_1[_i];
                    _this.registryTypeList.push({ code: r.registry_type_id, display: r.registry_type_name });
                    var registry = [];
                    for (var _a = 0, _b = r.data; _a < _b.length; _a++) {
                        var d = _b[_a];
                        registry.push({ code: d.registry_id, display: d.registry_name });
                    }
                    _this.registryList[r.registry_type_id] = registry;
                }
            }
        });
    };
    CampaignMeasureComponent.prototype.setId = function (id) {
        this.registryTypeId = id;
        this.registryId = {};
        this.setCampaignMeasureData();
    };
    CampaignMeasureComponent.prototype.onChange = function (e, index) {
        this.segments[index].registry_id = e;
        this.registryId['registry_id-' + index] = e;
        this.setCampaignMeasureData();
    };
    CampaignMeasureComponent.prototype.setCampaignMeasureData = function () {
        var mearue = [];
        for (var _i = 0, _a = this.segments; _i < _a.length; _i++) {
            var segment = _a[_i];
            var m = Object.assign(new Measure(), segment);
            delete m.segment_title;
            if (!m.registry_id) {
                delete m.registry_id;
            }
            mearue.push(m);
        }
        this.action.setCompRec(this.componentName, {
            campaign_id: this.campaignId,
            registry_type_id: this.registryTypeId,
            items: mearue
        });
    };
    CampaignMeasureComponent.prototype.trackBySegment = function (index, mearue) {
        return mearue.segment_id;
    };
    CampaignMeasureComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'campaign-measure',
                    template: "<div *ngIf=\"defMode === mode && registryTypeList.length > 0\" id=\"{{ componentName }}\">\n  <div class=\"row -m-3\">\n    <div class=\"col-sm-12\">\n      <column [key]=\"'form'\" [col]=\"{\n        key: 'registry_type_id',\n        controlType: 'radio',\n        required: true,\n        readonly: readonly,\n        params: { options: registryTypeList }\n      }\" [val]=\"{ registry_type_id: registryTypeId }\" [msg]=\"(msg | async)\" (setChangeVal)=\"setId($event.val)\"></column>\n    </div>\n  </div>\n  <div *ngIf=\"!readonly || (readonly && registryTypeId > 0)\" class=\"row -m-3\">\n    <div class=\"col-sm-12\">\n      <ul class=\"form form-campaign\">\n        <li *ngFor=\"let segment of segments; let index = index; trackBy: trackBySegment\" class=\"stageFlowPane\">\n          <div class=\"stageFlowPane_border\">\n            <dl class=\"form\">\n              <dt class=\"form_dt\"><label class=\"formLabelText\">{{ segment.segment_title }}</label></dt>\n              <dd class=\"form_dd\">\n                <ul>\n                  <li class=\"form_li form_li-w100per\">\n                    <columngroup [key]=\"'form'\" [col]=\"{\n                      key: 'registry_id-' + index,\n                      controlType: 'select2',\n                      readonly: readonly,\n                      params: {\n                        formClass: {width: '100per'},\n                        placeholder: (msg | async)['CampaignMeasureComponent.select2.placeholder'],\n                        options: registryList[registryTypeId]\n                      }\n                    }\" [val]=\"registryId\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event.val, index)\"></columngroup>\n                  </li>\n                </ul>\n              </dd>\n            </dl>\n          </div>\n        </li>\n      </ul>\n    </div>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    CampaignMeasureComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: CampaignService }
    ]; };
    return CampaignMeasureComponent;
}(ContentBaseComponent));
export { CampaignMeasureComponent };
var Measure = /** @class */ (function () {
    function Measure() {
        this.registry_id = 0;
    }
    return Measure;
}());
//# sourceMappingURL=campaign-measure.component.js.map